import { SuspendOrgMemberRequestSchema, SuspendOrgMemberResponseSchema } from './suspend-org-member.schema';
/**
 * Suspend Org Member Endpoint Contract
 * Suspends an active or pending organization member
 */ export const suspendOrgMemberContract = {
    method: 'POST',
    path: '/api/v2/org-member/:id/suspend',
    description: 'Suspend an organization member',
    requestSchema: SuspendOrgMemberRequestSchema,
    responseSchema: SuspendOrgMemberResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - user is inactive or already suspended',
            401: 'Unauthorized - user not authenticated',
            404: 'Not Found - organization member not found'
        }
    }
};

//# sourceMappingURL=suspend-org-member.contract.js.map